module.exports = __webpack_public_path__ + "static/media/general_settings.ce952e2b.svg";